var _circle, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFullOffertInfoMenuCloseIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 39,
    viewBox: "0 0 39 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 19.5,
    cy: 19.5,
    r: 19.5,
    fill: "url(#paint0_linear_1936_1329)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.224 20.2878L15.416 14.7998H16.744L19.896 19.3118L23.048 14.7998H24.36L20.552 20.2878L24.52 25.9998H23.192L19.896 21.2478L16.584 25.9998H15.256L19.224 20.2878Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1936_1329",
    x1: 39,
    y1: 19.5,
    x2: -5.84832e-8,
    y2: 19.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#192A7C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2364A4"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFullOffertInfoMenuCloseIcon);
export default __webpack_public_path__ + "static/media/full-offert-info-menu-close-icon.2b6f565d388008992cc971b866971f07.svg";
export { ForwardRef as ReactComponent };